import { useState } from "react";
import { Outlet, Link } from "react-router-dom";
import Sidebar from "../components/dashboard/demo/Sidebar";
import Topbar from "../components/dashboard/demo/Topbar";

export default function DashboardLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex min-h-screen bg-slate-50">
      {/* Desktop Sidebar */}
      <div className="hidden lg:block">
        <Sidebar />
      </div>

      {/* Mobile Overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 z-40 bg-black/40 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Mobile Sidebar */}
      <div
        className={`
          fixed inset-y-0 left-0 z-50 w-[280px] transform transition-transform duration-300 lg:hidden
          ${sidebarOpen ? "translate-x-0" : "-translate-x-full"}
        `}
      >
        <Sidebar onNavigate={() => setSidebarOpen(false)} />
      </div>

      {/* Main Content */}
      <div className="flex-1 min-w-0 flex flex-col">
        <Topbar onMenuClick={() => setSidebarOpen(true)} />

        <main className="flex-1 p-4 md:p-6 overflow-visible">
          <Outlet />

          <footer className="mt-10 border-t border-slate-200 pt-5 pb-2 text-sm text-slate-500 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <p>© 2026 RevUShield</p>

            <div className="flex flex-wrap items-center gap-4">
              <Link
                to="/legal/terms"
                className="hover:text-slate-900 transition"
              >
                Terms
              </Link>

              <Link
                to="/legal/privacy"
                className="hover:text-slate-900 transition"
              >
                Privacy
              </Link>

              <a
                href="mailto:support@revushield.com"
                className="hover:text-slate-900 transition"
              >
                Support
              </a>

              <span className="text-slate-400">v1.0</span>
            </div>
          </footer>
        </main>
      </div>
    </div>
  );
}
